import staging from '@/config/staging/default';
import production from '@/config/production/default';
import development from '@/config/development/default';

const envConfig = {
	staging,
	production,
	development,
};

export default envConfig[process.env.NODE_ENV] ||
	envConfig[process.env.NODE_ENV];
